module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAYAAABvEu28AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAqElEQVQokc3SQWoCQRCF4W9EyEbILjlAxMUcwU3IIgTc5ipeLXdwk1VuMegZnou0w4yOcZQsfFBNUd38Va/oKsSxHjHF7uTmrCZt9oK65DWWqMZBUo7kQ7KRfEveJCTPknXJL0RDqtbaDx6w6LR6QvP3NLvyZNIa/MTK725gjvdx1qAaXPYrZvi6DDhMNAy6Qn1r/6D7AW1LTLvFKz5yD9KC0incAmqwB4uVReKc5heLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cn.png
// module id = 1YwK
// module chunks = 1